"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketNameByMarketCode = exports.Market = void 0;
var Market;
(function (Market) {
  Market["CANADA"] = "CA";
  Market["CANADA_ONTARIO"] = "CA-ON";
  Market["CHILE"] = "CL";
  Market["ECUADOR"] = "EC";
  Market["ESTONIA"] = "EE";
  Market["FINLAND"] = "FI";
  Market["ICELAND"] = "IS";
  Market["MEXICO"] = "MX";
  Market["NORWAY"] = "NO";
  Market["PERU"] = "PE";
  Market["SWEDEN"] = "SE";
  Market["USA"] = "US";
  Market["USA_ARIZONA"] = "US-AZ";
  Market["USA_ARKANSAS"] = "US-AR";
  Market["USA_MASSACHUSETTS"] = "US-MA";
  Market["USA_MICHIGAN"] = "US-MI";
  Market["USA_MISSISSIPPI"] = "US-MS";
  Market["USA_NEVADA"] = "US-NV";
  Market["USA_NEW_YORK"] = "US-NY";
  Market["USA_WEST_VIRGINIA"] = "US-WV";
  Market["REST_OF_THE_WORLD"] = "ZZ";
})(Market || (exports.Market = Market = {}));
exports.MarketNameByMarketCode = {
  [Market.CANADA]: 'Canada',
  [Market.CANADA_ONTARIO]: 'Canada - Ontario',
  [Market.CHILE]: 'Chile',
  [Market.ECUADOR]: 'Ecuador',
  [Market.ESTONIA]: 'Estonia',
  [Market.FINLAND]: 'Finland',
  [Market.ICELAND]: 'Iceland',
  [Market.MEXICO]: 'Mexico',
  [Market.NORWAY]: 'Norway',
  [Market.PERU]: 'Peru',
  [Market.SWEDEN]: 'Sweden',
  [Market.USA]: 'USA',
  [Market.USA_ARIZONA]: 'USA - Arizona',
  [Market.USA_ARKANSAS]: 'USA - Arkansas',
  [Market.USA_MASSACHUSETTS]: 'USA - Massachusetts',
  [Market.USA_MICHIGAN]: 'USA - Michigan',
  [Market.USA_MISSISSIPPI]: 'USA - Mississippi',
  [Market.USA_NEVADA]: 'USA - Nevada',
  [Market.USA_NEW_YORK]: 'USA - New York',
  [Market.USA_WEST_VIRGINIA]: 'USA - West Virginia',
  [Market.REST_OF_THE_WORLD]: 'Rest of the world'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL21hcmtldC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLE1Bc0JYO0FBdEJELFdBQVksTUFBTTtJQUNkLHVCQUFhLENBQUE7SUFDYixrQ0FBd0IsQ0FBQTtJQUN4QixzQkFBWSxDQUFBO0lBQ1osd0JBQWMsQ0FBQTtJQUNkLHdCQUFjLENBQUE7SUFDZCx3QkFBYyxDQUFBO0lBQ2Qsd0JBQWMsQ0FBQTtJQUNkLHVCQUFhLENBQUE7SUFDYix1QkFBYSxDQUFBO0lBQ2IscUJBQVcsQ0FBQTtJQUNYLHVCQUFhLENBQUE7SUFDYixvQkFBVSxDQUFBO0lBQ1YsK0JBQXFCLENBQUE7SUFDckIsZ0NBQXNCLENBQUE7SUFDdEIscUNBQTJCLENBQUE7SUFDM0IsZ0NBQXNCLENBQUE7SUFDdEIsbUNBQXlCLENBQUE7SUFDekIsOEJBQW9CLENBQUE7SUFDcEIsZ0NBQXNCLENBQUE7SUFDdEIscUNBQTJCLENBQUE7SUFDM0Isa0NBQXdCLENBQUE7QUFDNUIsQ0FBQyxFQXRCVyxNQUFNLHNCQUFOLE1BQU0sUUFzQmpCO0FBRVksUUFBQSxzQkFBc0IsR0FBMkI7SUFDMUQsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEVBQUUsUUFBUTtJQUN6QixDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsRUFBRSxrQkFBa0I7SUFDM0MsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEVBQUUsT0FBTztJQUN2QixDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsRUFBRSxTQUFTO0lBQzNCLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUFFLFNBQVM7SUFDM0IsQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLEVBQUUsU0FBUztJQUMzQixDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsRUFBRSxTQUFTO0lBQzNCLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLFFBQVE7SUFDekIsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLEVBQUUsUUFBUTtJQUN6QixDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxNQUFNO0lBQ3JCLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLFFBQVE7SUFDekIsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLEVBQUUsS0FBSztJQUNuQixDQUFDLE1BQU0sQ0FBQyxXQUFXLENBQUMsRUFBRSxlQUFlO0lBQ3JDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxFQUFFLGdCQUFnQjtJQUN2QyxDQUFDLE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxFQUFFLHFCQUFxQjtJQUNqRCxDQUFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsRUFBRSxnQkFBZ0I7SUFDdkMsQ0FBQyxNQUFNLENBQUMsZUFBZSxDQUFDLEVBQUUsbUJBQW1CO0lBQzdDLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxFQUFFLGNBQWM7SUFDbkMsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLEVBQUUsZ0JBQWdCO0lBQ3ZDLENBQUMsTUFBTSxDQUFDLGlCQUFpQixDQUFDLEVBQUUscUJBQXFCO0lBQ2pELENBQUMsTUFBTSxDQUFDLGlCQUFpQixDQUFDLEVBQUUsbUJBQW1CO0NBQ2xELENBQUMifQ==